import { Dialog, DialogContent } from "@mui/material";
import React from "react";
import ViewReverse from "./ViewReverse";
import Text from "./Text";
import { fontSizes } from "../constants/constants";
import dynamicfunction from "../utils/dynamicfunction";
import icons from "../constants/icons";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { getContentKeyAccToLang } from "../utils/utils";
import PdfViewer from "./PdfViewer";

const TermsModal = ({ isOpen, onClose, title, src, url }) => {
  const { TextWeight, isArabic } = dynamicfunction();
  const { fundsContent } = useSelector((state) => state.content);
  const { fund_document } = useSelector((state) => state.fund);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_subscribe?.data?.attributes,
      key,
      isArabic
    );
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="lg">
      <DialogContent sx={{ padding: 0 }}>
        <ViewReverse
          className={
            "items-center py-4 px-8 justify-between bg-white shadow-lg rounded-tr rounded-tl"
          }
        >
          <Text
            text={title}
            size={fontSizes.h24}
            weight={TextWeight.bold}
            color="text-primary"
          />
          <ReactSVG
            src={icons.cross}
            onClick={onClose}
            className="cursor-pointer"
          />
        </ViewReverse>

        {src || url ? <PdfViewer src={src} url={url} /> : null}
        {fund_document ? (
          <PdfViewer src={fund_document?.termsAndCondition} />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default TermsModal;
